type ElectricityCost = { cost: number } & unknown;

export function getCost(costs: ElectricityCost[] | undefined): number | undefined {
  if (costs === undefined || costs.length === 0) {
    return undefined;
  }
  return costs[0].cost;
}
